import Vue from 'vue';
import Vuex from 'vuex';
import system from './modules/system'
import layout from './modules/layout'
Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV!='production',
    modules: {
        system,
        layout,
        showMbTopMenu: false,
        navList: [],
    },
    // state: {
    //     showMbTopMenu: false,
    //     navList: [],
    // },
    mutations: {
        toggleMbTopMenu(state, status) {
            state.showMbTopMenu = status;
        },
        storeNavList(state, data){
            state.navList = data;
        }
    }
})